import type { ReactNode } from "react"
import { Navigate, useSearchParams } from "react-router-dom"
import { useAppSelector } from "@/store"

export const AVAILABILITY_PATH = "/appointments/availability"

/**
 * Where /appointments/schedule-overrides goes once AmsAvailabilityWeekView is on: the Availability
 * page, on the same site when the link named one (`?site=<slug>`). Nothing else carries over; the
 * Availability page opens on the site's schedule in the current week.
 */
export function availabilityRedirectTarget(params: URLSearchParams): string {
  const site = params.get("site")?.trim()
  if (!site) return AVAILABILITY_PATH
  return `${AVAILABILITY_PATH}?${new URLSearchParams({ site }).toString()}`
}

/**
 * The Schedule Overrides route (AB#807). With AmsAvailabilityWeekView on, overrides are made on the
 * Availability week view, so a bookmark or old link is sent there. With the flag off (or before the
 * features are read) the old page renders exactly as it always did.
 */
export function ScheduleOverridesRoute({ children }: { children: ReactNode }) {
  // Read as the availability page reads it: absent (no slice, not yet read) means off.
  const weekViewOn = useAppSelector((state) => state.features?.features.amsAvailabilityWeekView ?? false)
  const [params] = useSearchParams()

  if (weekViewOn) return <Navigate to={availabilityRedirectTarget(params)} replace />
  return <>{children}</>
}
